import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">6080电影网</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              6080电影网 - 致力于为广大影迷提供最新、最全的电影在线观看服务。高清画质不缓冲，免费无广告，极速秒开，让您随时随地畅享观影乐趣。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">
                  电影分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/category/action" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">
                  动作片
                </Link>
              </li>
              <li>
                <Link to="/category/scifi" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">
                  科幻片
                </Link>
              </li>
              <li>
                <Link to="/category/comedy" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">
                  喜剧片
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap">
                  爱情片
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-mail-line text-base"></i>
                <span>contact@6080dy.com</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-6080</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市朝阳区光华路9号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">© 2026 6080电影网 版权所有</p>
          <p className="text-foreground-500 text-xs">最新电影 · 新片上映 · 高清不缓冲 · 免费无广告</p>
        </div>
      </div>
    </footer>
  );
}